module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _c('br'), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 12,
      "lg": 6,
      "align": "left"
    }
  }, [_c('sites-stats-table', {
    attrs: {
      "stats": _vm.stats
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 12,
      "lg": 12,
      "align": "right"
    }
  }, [_c('sites-chart', {
    attrs: {
      "show-legend": false,
      "stats": _vm.stats
    }
  })], 1), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 6,
      "align": "center"
    }
  }, [_c('ways-summary-report')], 1) : _vm._e(), _vm._v(" "), (_vm.isTowerCo()) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('sharing-summary-report')], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.isTowerCo()) ? _c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Requests")]) : _vm._e(), _vm._v(" "), _c('requests-report', {
    attrs: {
      "summary": true
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Operations")]), _vm._v(" "), _c('op-stats')], 1), _vm._v(" "), (_vm.isTelco() || _vm.canAccess('project|maintenance|management')) ? _c('div', [_c('el-row', [_c('div', {
    staticClass: "dash-heading"
  }, [_vm._v("Requests Calendar")])]), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "requests"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Project Summary")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4f6019c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/views/ProjectSummary.vue
// module id = 1740
// module chunks = 0